import { MatDateFormats } from '@angular/material/core';

export const DD_MM_YYYY_DATE_FORMATS: MatDateFormats = {
  parse: {
    dateInput: null,
    timeInput: null
  },
  display: {
    dateInput: { day: '2-digit', month: '2-digit', year: 'numeric' },
    timeInput: { hour: 'numeric', minute: 'numeric' },
    monthYearLabel: { year: 'numeric', month: 'short' },
    dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'long' },
    timeOptionLabel: { hour: 'numeric', minute: 'numeric' }
  }
};
